import { toUrlParams } from './toUrlParams';
import { fetchUrlParams } from '../../helpers/fetchUrlParams';

export const replaceUrlParams = (urlParams = {}) => {
  const currentUrlParams = fetchUrlParams(location.search);

  history.replaceState({}, '', toUrlParams({ ...currentUrlParams, ...urlParams }));
};
